module.exports = __webpack_public_path__ + "img/login-bgc-1.c0851764.png";